<mat-card appearance="outlined" class="col-12 stretch">
  <mat-card-header> All Annuities and Riders by Connector </mat-card-header>
  <mat-card-content>
    <span>
      <div mat-dialog-content class="dialog-container">
        <div class="row">
          <mat-form-field class="col-6">
            <input matInput placeholder="Connector Name" [(ngModel)]="name" />
          </mat-form-field>
          <div class="col-3"></div>
          <div class="col-3">
            <button
              type="button"
              mat-button
              class="header-button download-link"
              (click)="download()"
            >
              <mat-icon>save</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </span>
  </mat-card-content>
</mat-card>
